// Copyright (c) 2017 Deere & Company

const classes = {
    error: 'error-text',
    info: 'help-text',
    success: 'success-text',
    warning: 'caution-text'
};

export const getAlertBarClass = key => key in classes ? classes[key] : classes.info;



// WEBPACK FOOTER //
// ./src/shared/components/inline-alert-bar/services/alert-bar-class.js